import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Bps } from "./breakpoints";
import { PrimaryButton } from "./button";
import parse from "html-react-parser";
import { Modal } from "./modal";
import { ModalVideo } from "./modalvideo";

const Wrapper = styled.section`
  padding: 0 var(--edge-padding);

  ${Bps.m} {
    padding: 72px var(--edge-padding);
    display: flex;
    flex-direction: row;
    gap: 40px;
    justify-content: space-between;
  }
  ${Bps.lg} {
    padding: 84px 130px;
  }
  & > div:first-of-type {
    ${Bps.lg} {
      width: 40%;
    }
  }
  & > div:last-of-type {
    ${Bps.lg} {
      width: 60%;
    }
  }
`;
const Heading = styled.h1`
  color: var(--primary-color);
  text-align: left;
  padding: 36px 0;
  display: block;
  z-index: 3;
  line-height: 36px;
  position: relative;
  font-weight: 900;
  font-size: 26px;

  ${Bps.m} {
    padding: 0;
    padding-bottom: 36px;
    font-size: 34px;
    line-height: 40px;
  }
`;
const EmphWrapper = styled.span`
  display: block;
  position: relative;
  z-index: 1;
`;
const HeadingEmph = styled.span`
  box-decoration-break: clone;
  line-height: 32px;
  z-index: 3;
  position: relative;
  ${Bps.m} {
    font-size: 36px;
    line-height: 40px;
  }
`;
const Scribble = styled.span`
  position: absolute;
  top: -8px;
  left: 0;
  width: 200px;
  height: 59px;
  transform: rotate(0deg);
  z-index: 0;

  ${Bps.lg} {
    top: -8px;
    left: 0;
    width: 266px;
    height: 59px;
  }
  & svg {
    width: 100%;
    height: 100%;
  }
`;
const SecondaryHeading = styled.h3`
  margin-top: 48px;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  padding-bottom: 30px;
  text-transform: uppercase;
  ${Bps.m} {
    margin-top: 0px;
  }
`;
const HeroContent = styled.p`
  color: var(--primary-color);
  text-align: left;
  padding-bottom: 56px;
  ${Bps.m} {
    max-width: 316px;
  }
  ${Bps.lg} {
    max-width: fit-content;
  }
`;

const Cta = (props) => {
  return (
    <Wrapper {...props}>
      <div>
        <Heading as="h2">
          {props.headingpre}
          <EmphWrapper>
            <HeadingEmph> {props.headingemph}</HeadingEmph>
            <Scribble>
              <svg
                width="424px"
                height="97px"
                viewBox="0 0 424 97"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Path</title>
                <g
                  id="Landing-Page"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  stroke-linecap="round"
                >
                  <g
                    id="Landing-1280-Copy-2"
                    transform="translate(-511.000000, -193.000000)"
                    stroke="#FFC88C"
                    stroke-width="3"
                  >
                    <path
                      d="M837.553741,216.374156 C804.765098,216.374156 771.964688,215.337654 739.187812,216.374156 C232.796102,232.38777 853.695586,213.953101 624.139845,227.245849 C605.459989,228.327533 586.696387,225.825014 568.032852,227.245849 C555.608368,228.191713 543.093637,235.959343 532.829612,243.449802 C529.410143,245.945255 520.154147,249.106299 523.261787,252.116574 L522.275328,259.58963 C526.010777,263.208044 531.369828,263.677593 536.140104,264.591398 C549.89156,267.225658 563.751536,269.327747 577.663375,270.199889 C604.207804,271.863978 630.828503,270.997662 657.391065,272.192704 C777.747891,277.607527 694.143415,280.433058 846.448599,276.533489 C873.907935,275.83043 902.199417,273.29657 929.302865,267.156407 C930.361397,266.916602 931.430497,266.018106 931.890232,264.86763 C932.505063,263.32903 932.791535,261.358355 932.249705,259.782006 C931.656258,258.055488 930.152008,256.926054 928.817995,255.929559 C924.973558,253.0578 921.039609,250.255228 916.81746,248.254262 C898.791784,239.711508 879.064344,234.240288 860.004062,230.605025 C799.388019,219.04406 736.506526,223.357461 675.874647,232.336406 C658.827077,234.860972 622.684767,238.582796 604.352129,250.720617 C599.664449,253.824275 585.654069,259.253863 590.809206,261.049712 C608.359554,267.163569 627.368992,263.222564 645.599526,265.089602 C675.606798,268.162727 705.459441,273.237789 735.496948,275.867573 C764.434197,278.40103 793.500627,278.344918 822.45589,280.573379 C842.202964,282.093157 861.816371,285.600617 881.564061,287.10922 C883.03313,287.221448 914.259164,291.847596 920.090334,281.352747 C920.984001,279.744339 921.038382,277.378061 920.424727,275.596274 C919.836533,273.888416 918.213462,272.931412 916.867619,271.995396 C912.431916,268.910424 907.905842,265.950916 903.16168,263.590058 C871.605765,247.886753 838.541301,235.373917 804.946228,227.497418 C734.463616,210.972488 661.724119,211.302977 590.224018,212.516777 C572.515073,212.817408 511.383052,216.01558 512.552846,238.22113 C513.005082,246.805669 551.085706,253.813466 559.430588,254.972613 C589.213281,259.109583 619.041761,262.850431 648.922558,265.844306 C664.693293,267.424439 680.518778,268.354315 696.343688,268.69048 C754.342223,269.922531 823.894768,268.608839 881.292367,264.186916 C933.661289,260.152403 863.663865,227.155849 850.720472,222.673227 C835.867359,217.529222 820.996404,212.352153 805.878349,208.42756 C789.637867,204.211589 773.20356,201.029406 756.739274,198.276043 C727.522976,193.390129 653.512076,195.78163 644.094757,195.972467 C603.460213,196.795904 561.644838,211.81091 522.772737,222.475919"
                      id="Path"
                    ></path>
                  </g>
                </g>
              </svg>
            </Scribble>
          </EmphWrapper>
          {props.headingpost}
        </Heading>
        <ModalVideo {...props} />
      </div>
      <div>
        <SecondaryHeading>{props.secondaryheading}</SecondaryHeading>
        <HeroContent>{props.ctacontent}</HeroContent>
      </div>
    </Wrapper>
  );
};

export { Cta };
